import React from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';

import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';
import LinkCode from '../../components/LinkCode';

const EnterLinkCodePage = ({ saveEnterLinkCodeForm, getBusinessData }) => (
  <Form
    onSubmit={saveEnterLinkCodeForm}
    initialValues={getBusinessData}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <Content>
          {({ enterLinkCodePageHeading, enterLinkCodePageDescription, enterLinkCodeSubmit }) => (
            <div>
              <PageHeading>{enterLinkCodePageHeading}</PageHeading>

              <p>{enterLinkCodePageDescription}</p>

              <LinkCode />

              <Submit submitButtonText={enterLinkCodeSubmit} />
            </div>
          )}
        </Content>
      </form>
    )}
  />
);

EnterLinkCodePage.propTypes = {
  saveEnterLinkCodeForm: PropTypes.func.isRequired
};

export default EnterLinkCodePage;
